import { FilterOutlined } from "@ant-design/icons";
import { Button, Select } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { onError } from "src/common/onError";
import { PageSubheader } from "src/components/PageSubheader";
import { ToolBox2 } from "src/components/ToolBox2";

import * as styles from "./SpecificationsAccessEditor.module.less";
import { SpecificationsAccessStore } from "./SpecificationsAccessStore";
import { SpecsListAccessEditor } from "./SpecsListAccessEditor";

type PropsSpecificationsAccessEditor = {
  title: string;
  store: SpecificationsAccessStore;
};

export const SpecificationsAccessEditor: React.FC<PropsSpecificationsAccessEditor> =
  observer((props) => {
    const { title, store } = props;
    return (
      <>
        <PageSubheader title={title}>
          <Button
            type="primary"
            loading={store.saving}
            onClick={() => store.save().catch(onError)}
          >
            Сохранить
          </Button>
        </PageSubheader>
        <ToolBox2 paddingMode="page">
          <div className={styles.content}>
            <Select
              mode="multiple"
              maxTagCount="responsive"
              allowClear
              options={store.allRoles}
              value={store.visibleRoles}
              onChange={(value) => store.setVisibleRoles(value)}
              prefix={<FilterOutlined />}
            />
            <div className={styles.specBlock}>
              <div className={styles.specLabel}>Первичная спецификация</div>
              <SpecsListAccessEditor
                specList={store.getSpecs("PRIMARY")}
                store={store}
              />
            </div>
            <div className={styles.specBlock}>
              <div className={styles.specHeaderBox}>
                <div className={styles.specLabel}>Вторичная спецификация</div>
                {/* <div className={styles.specComment}>Тип привязки: Прямая</div> */}
              </div>
              <SpecsListAccessEditor
                specList={store.getSpecs("SECONDARY")}
                store={store}
              />
            </div>
          </div>
        </ToolBox2>
      </>
    );
  });
